import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-field-password',
  template: `
    <div class="d-flex">
      <input
        [type]="showPassword ? 'text' : 'password'"
        class="form-control"
        [ngClass]="{ 'is-invalid': !formControl.valid && formControl.touched && !field.props?.disabled }"
        [formControl]="formControl"
        [attr.disabled]="field.props?.disabled ? true : null"
        [attr.readonly]="field.props?.readonly ? true : null"
        [formlyAttributes]="field"
      />
      <chitin-button
        variant="text"
        [icon]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
        iconPosition="center"
        (clicked)="showPassword = !showPassword"
        label=""
      />
    </div>
  `,
})
export class FormlyFieldPasswordComponent extends FieldType<FieldTypeConfig> implements OnInit {
  showPassword: boolean = false;

  ngOnInit() {
    if (this.field.props?.showPassword) {
      this.showPassword = this.field.props.showPassword;
    }
  }
}
